import React, { useContext } from 'react'
import type { ICurrency } from 'lib/helpers'

export interface CurrencyContextValue {
	currencies: Record<string, ICurrency>
	setCurrencies: React.Dispatch<React.SetStateAction<Record<string, ICurrency>>>
}

const CurrencyContext = React.createContext<CurrencyContextValue | null>(null)

export const useCurrencyContext = (): CurrencyContextValue => {
	const context = useContext(CurrencyContext)
	if (!context) {
		throw new Error('useCurrencyContext must be used within a CurrencyProvider')
	}
	return context
}

export default CurrencyContext
